import { AxiosPromise } from "axios";
import {
  AffiliateDto,
  CreateUserWithLocationPermissions,
  DesignDto, DownloadedItemDto,
  LocationDto, MemberLocationPermissionDto,
  MemberResourceApi, PastDueStatusDto, QuestionnaireAnswerDto,
  RegMemberDto,
  UpdatePasswordRequest
} from "../generated/dashboard-client";
import {dashboardApiConfig, ops} from "./config";
import {
  MemberDto,
  MembersResourceApi,
  RegisterMemberDto,
  UpdateMemberDto,
  UpdateMemberRoleBodyRoleEnum
} from "../generated/dashboard-client";

const api = new MemberResourceApi(dashboardApiConfig);
const accountApi = new MembersResourceApi(dashboardApiConfig);

const MembersApi = {
  updateRole(memberId: string, role: UpdateMemberRoleBodyRoleEnum) {
    return accountApi.updateMemberRole(memberId, {role}, ops())
  },

  getMemberLocations(id: number): AxiosPromise<LocationDto[]> {
    return api.getMemberLocations(id, ops());
  },

  getUnpaidInvoicePaymentPageUrl(): AxiosPromise<PastDueStatusDto> {
    return api.getUnpaidInvoicePaymentPageUrl(ops());
  },

  sendToastLead(member: RegMemberDto): AxiosPromise<void> {
    return api.sendToast(member, ops());
  },

  sendAffiliateLead(affiliate: AffiliateDto): AxiosPromise<void> {
    return api.sendAffiliate(affiliate, ops());
  },

  sendMultiRegLead(member: RegMemberDto): AxiosPromise<void> {
    return api.sendMultiRegEmail(member, ops());
  },

  registerMember(dto: RegisterMemberDto): AxiosPromise<MemberDto> {
    return accountApi.register1(dto, ops());
  },

  updateMemberUrl(memberId: string, url: string): AxiosPromise<MemberDto> {
    return accountApi.updateMemberWebsiteUrl(memberId, {url}, ops());
  },

  updateInterest(id: string, dto: UpdateMemberDto): AxiosPromise<void> {
    return accountApi.updateMemberInterest(id, dto, ops());
  },

  generatePassword(email: string): AxiosPromise<void> {
    return api.generatePassword({email}, ops());
  },

  updatePassword(dto: UpdatePasswordRequest): AxiosPromise<void> {
    return api.updatePassword(dto, ops());
  },

  saveQuestionnaire(memberEmail: string, dto: QuestionnaireAnswerDto): AxiosPromise<void> {
    return api.saveQuestionnaire(memberEmail, dto, ops());
  },

  getDesignsSharedWithMe(): AxiosPromise<DesignDto[]> {
    return api.getDesignsSharedWithMe(ops());
  },

  increaseMemberLoginCount(memberId: number): AxiosPromise<void> {
    return accountApi.increaseMemberLoginCount(memberId, ops());
  },

  downloadImg(url: string): AxiosPromise<DownloadedItemDto> {
    return api.downloadImg(url, ops());
  },

  createNewUserInTeam(dto: CreateUserWithLocationPermissions): AxiosPromise<void> {
    return api.createNewUserInTeam(dto, ops());
  },

  updateUserLocationPermissions(id: string, dto: CreateUserWithLocationPermissions): AxiosPromise<void> {
    return api.updateUserLocationPermissions(id, dto, ops());
  },

  getOwnerTeamLocationPermissions(id: string): AxiosPromise<MemberLocationPermissionDto[]> {
    return api.getOwnerTeamLocationPermissions(id, ops());
  },

  getUserTeamLocationPermissions(id: string): AxiosPromise<MemberLocationPermissionDto[]> {
    return api.getUserTeamLocationPermissions(id, ops());
  },

  getBatchTeamLocationPermissions(ids: string[]): AxiosPromise<Record<string, MemberLocationPermissionDto[]>> {
    return api.getBatchTeamLocationPermissions(ids, ops());
  },

  deleteUserTeamLocationPermissions(id: string): AxiosPromise<void> {
    return api.deleteUserTeamLocationPermissions(id, ops());
  },

  validateUserInviteEmail(email: string): AxiosPromise<void> {
    return accountApi.validateInviteEmail(email, ops());
  },

  updateMemberDiningRDFlag(internalId: number, flag: boolean): AxiosPromise<void> {
    return accountApi.updateMemberDiningRDFlag(internalId, flag, ops());
  },

  getHolidayTemplatesEnabled(): AxiosPromise<boolean> {
    return accountApi.getHolidayTemplatesEnabled(ops());
  },

  updateHolidayTemplatesEnabled(flag: boolean): AxiosPromise<void> {
    return accountApi.updateHolidayTemplatesEnabled(flag, ops());
  }
};

export default MembersApi;
